const RecommendationIndustryViewClient = {
  getCourseToipcUrl: "/candidate/list_topics",
  getCourseVideoUrl: "/candidate/list_videos",
  labSession: "/lab_sessions",
};

export default RecommendationIndustryViewClient;
